'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var PeerId = require('peer-id');

var basePacket = {
  success: true,
  time: 0,
  text: ''
};

module.exports = function (_ref2) {
  var libp2p = _ref2.libp2p;
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, options) {
      var peerInfo, packetCount, totalTime, i, time, average;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              options.count = options.count || 10;

              if (!PeerId.isPeerId(peerId)) {
                peerId = PeerId.createFromCID(peerId);
              }

              if (!libp2p.peerStore.has(peerId)) {
                _context.next = 7;
                break;
              }

              peerInfo = libp2p.peerStore.get(peerId);
              _context.next = 12;
              break;

            case 7:
              _context.next = 9;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                text: "Looking up peer ".concat(peerId)
              });

            case 9:
              _context.next = 11;
              return _awaitAsyncGenerator(libp2p.peerRouting.findPeer(peerId));

            case 11:
              peerInfo = _context.sent;

            case 12:
              _context.next = 14;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                text: "PING ".concat(peerInfo.id.toB58String())
              });

            case 14:
              packetCount = 0;
              totalTime = 0;
              i = 0;

            case 17:
              if (!(i < options.count)) {
                _context.next = 35;
                break;
              }

              _context.prev = 18;
              _context.next = 21;
              return _awaitAsyncGenerator(libp2p.ping(peerInfo));

            case 21:
              time = _context.sent;
              totalTime += time;
              packetCount++;
              _context.next = 26;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                time: time
              });

            case 26:
              _context.next = 32;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](18);
              _context.next = 32;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                success: false,
                text: _context.t0.toString()
              });

            case 32:
              i++;
              _context.next = 17;
              break;

            case 35:
              if (!packetCount) {
                _context.next = 39;
                break;
              }

              average = totalTime / packetCount;
              _context.next = 39;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                text: "Average latency: ".concat(average, "ms")
              });

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[18, 28]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};